import axios from 'axios';
import { log } from '../../utils/logger';
export const API_BASE_URL = window._env_.REACT_APP_SIGNO_API_URL;
export const postPayment = (body) => {
    log.debug(`Calling API to do payment for company id ${body.companyId}`);
    return axios.post(`${API_BASE_URL}/Payment/Card`, body);
};
export const postPaymentResponse = (body) => {
    log.debug(`Calling API to save Redsys payment response to our systems`);
    return axios.post(`${API_BASE_URL}/Payment/Response`, body);
};
export const getCollectivePrices = (collectiveId, isTerritorySpecial, serviceId = 1) => {
    log.debug(`Calling API to get assigned price to colelctive`);
    return axios.get(`${API_BASE_URL}/Prices/${collectiveId}/${serviceId}/${isTerritorySpecial}`);
};
export const getCollectivePricesWithDiscountCoupon = (collectiveId, discountCode, isTerritorySpecial) => {
    log.debug(`Calling API to get assigned price to colelctive`);
    return axios.get(`${API_BASE_URL}/Promotion/${collectiveId}/${discountCode}/${isTerritorySpecial}/validate`);
};
